<template>
  <v-container>
    <div class="editorx_body">
      <!--editorjs id-->
      <div class :id="`codex-editor-${id}`" />
    </div>
    <slot />
  </v-container>
</template>

<script>
import EditorJS from "@editorjs/editorjs";
import Header from "editorjs-header-with-anchor";
import Paragraph from "@editorjs/paragraph";
import List from "@editorjs/list";
import SimpleImage from "@editorjs/simple-image";

export default {
  name: "editor",
  data() {
    return {
      editor: null,
      id: (Math.random() + new Date().getTime()) * 10000000,
    };
  },
  props: {
    readOnly: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => ({ version: "2.22.2", blocks: [], time: 1641315990360 }),
    },
  },
  mounted() {
    this.data = JSON.parse(JSON.stringify(this.data));
  },
  watch: {
    data: function (newVal) {
      try {
        // console.log(newVal);
        this.editor.render(newVal);
      } catch (e) {
        this.setupEditor();
      }
    },
    readOnly: function () {
      try {
        this.editor.readOnly.toggle();
      } catch (e) {
        console.log(e);
      }
    },
  },
  computed: {
    editorData(data) {
      return JSON.parse(JSON.stringify(data));
    },
  },
  methods: {
    childSave() {
      return this.editor.save().then((savedData) => {
        return savedData;
      });
    },
    setupEditor() {
      this.editor = new EditorJS({
        minHeight: 0,
        readOnly: !this.$props.readOnly,
        holder: `codex-editor-${this.id}`,
        autofocus: true,
        onReady: function () {
          console.log("ready");
        },
        onChange: () => {
          this.editor.save().then((savedData) => {
            this.$emit("update", savedData);
          });
        },
        data: this.$props.data,
        tools: {
          header: {
            class: Header,
            shortcut: "CMD+SHIFT+H",
            config: {
              placeholder: "Enter a header",
              levels: [1, 2, 3, 4],
              defaultLevel: 3,
              allowAnchor: true,
              anchorLength: 100,
            },
          },
          list: {
            class: List,
          },
          paragraph: {
            class: Paragraph,
            config: {
              placeholder: ".",
            },
          },
          image: {
            class: SimpleImage,
            inlineToolbar: true,
            config: {
              placeholder: "Paste image URL",
            },
          },
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.codex-editor__redactor {
  display: none;
}
</style>

